module.exports = __webpack_public_path__ + "img/logo-nutrimix-distribuidora.7f52dc68.svg";